export default __webpack_public_path__ + "static/media/Solitary Auditory Learner.ddea5249.png";